import reactions from './reactions';
import rootReducer from './rootReducer/reducer';
import { createStore, applyMiddleware, compose } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

const reaction = (store) => (next) => (action) => {
  const result = next(action);

  if (reactions[action.type]) {
    reactions[action.type].forEach((fn) => {
      fn(action, next, store.getState);
    });
  }

  return result;
};

const composeEnhancers = process.env.NODE_ENV === 'development' ? composeWithDevTools : compose;

const store = createStore(rootReducer, undefined, composeEnhancers(applyMiddleware(reaction)));

export default store;
